(function () {
  'use strict';

  const TIERS = [
    { min: 1,  max: 4,    discount: 0    },
    { min: 5,  max: 7,    discount: 0.10 },
    { min: 8,  max: 11,   discount: 0.15 },
    { min: 12, max: 29,   discount: 0.20 },
    { min: 30, max: 49,   discount: 0.30 },
    { min: 50, max: 9999, discount: 0.35 },
  ];

  function getTier(qty) {
    for (let i = TIERS.length - 1; i >= 0; i--) {
      if (qty >= TIERS[i].min) return TIERS[i];
    }
    return TIERS[0];
  }

  function getNextTier(qty) {
    for (let i = 0; i < TIERS.length; i++) {
      if (TIERS[i].min > qty) return TIERS[i];
    }
    return null;
  }

  function formatMoney(cents, fmt) {
    var amount = cents / 100;
    fmt = fmt || (window.Shopify && window.Shopify.money_format) || '€{{amount}}';
    // Strip any HTML tags (e.g. dual-currency app wrappers like <div class="dualPrice">)
    fmt = fmt.replace(/<[^>]+>/g, '').trim();
    if (fmt.indexOf('amount_with_comma_separator') !== -1) {
      return fmt.replace('{{amount_with_comma_separator}}', amount.toFixed(2).replace('.', ','));
    }
    if (fmt.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
      return fmt.replace('{{amount_no_decimals_with_comma_separator}}', Math.round(amount).toString());
    }
    if (fmt.indexOf('amount_no_decimals') !== -1) {
      return fmt.replace('{{amount_no_decimals}}', Math.round(amount).toString());
    }
    return fmt.replace('{{amount}}', amount.toFixed(2));
  }

  function updatePricing(container) {
    var sectionId = container.dataset.sectionId;
    var basePrice = parseInt(container.dataset.basePrice, 10);
    var moneyFmt  = container.dataset.moneyFormat || null;
    if (!basePrice || isNaN(basePrice)) return;

    var qtyInput = document.getElementById('Quantity-' + sectionId);
    var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || 1, 10));

    var tier = getTier(qty);
    var nextTier = getNextTier(qty);
    var unitPrice = Math.round(basePrice * (1 - tier.discount));
    var totalPrice = unitPrice * qty;
    var totalSavings = (basePrice - unitPrice) * qty;

    // --- Update main price display ---
    var priceBlock = container.closest('.hdt-product__price');
    if (priceBlock) {
      var moneyEl = priceBlock.querySelector('.hdt-price__sale hdt-price .hdt-money');
      if (moneyEl) {
        moneyEl.textContent = formatMoney(unitPrice, moneyFmt);
        moneyEl.style.color = tier.discount > 0 ? '#f98e69' : '';
      }
    }

    // --- Highlight active tier row ---
    container.querySelectorAll('.ff-tier-row[data-tier-min]').forEach(function (row) {
      var rMin = parseInt(row.dataset.tierMin, 10);
      var rMax = parseInt(row.dataset.tierMax, 10);
      row.classList.toggle('is-active', qty >= rMin && qty <= rMax);
    });

    // --- Update per-tier prices in table ---
    container.querySelectorAll('.ff-tier-row[data-tier-min]').forEach(function (row) {
      var d = parseFloat(row.dataset.discount) || 0;
      var el = row.querySelector('.ff-tier-price');
      if (el) el.textContent = formatMoney(Math.round(basePrice * (1 - d)), moneyFmt);
    });

    // --- Update summary bar ---
    var qtyDisplay   = document.getElementById('ff-qty-display-' + sectionId);
    var totalEl      = document.getElementById('ff-total-price-' + sectionId);
    var savingsEl    = document.getElementById('ff-savings-' + sectionId);
    var nextTierEl   = document.getElementById('ff-next-tier-' + sectionId);
    var klarnaEl     = document.getElementById('ff-klarna-amount-' + sectionId);

    if (qtyDisplay) qtyDisplay.textContent = qty;
    if (totalEl)    totalEl.textContent = formatMoney(totalPrice, moneyFmt);
    if (klarnaEl)   klarnaEl.textContent = formatMoney(Math.ceil(totalPrice / 3), moneyFmt);

    if (savingsEl) {
      if (totalSavings > 0) {
        savingsEl.textContent = 'You save ' + formatMoney(totalSavings, moneyFmt);
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }

    if (nextTierEl) {
      if (nextTier) {
        var needed = nextTier.min - qty;
        var pct = Math.round(nextTier.discount * 100);
        nextTierEl.textContent = 'Add ' + needed + ' more meter' + (needed !== 1 ? 's' : '') + ' to unlock ' + pct + '% off';
        nextTierEl.hidden = false;
      } else {
        nextTierEl.textContent = '🎉 Maximum discount applied!';
        nextTierEl.hidden = false;
      }
    }
  }

  function initVolumePricing() {
    document.querySelectorAll('.ff-volume-tiers[data-section-id]').forEach(function (container) {
      var sectionId = container.dataset.sectionId;
      var formId    = container.dataset.formId;

      // Initial render
      updatePricing(container);

      // Range slider (primary input)
      var rangeSlider = document.getElementById('QuantityRange-' + sectionId);
      if (rangeSlider) {
        rangeSlider.addEventListener('input', function () { updatePricing(container); });
      }

      // Number input (secondary / fallback)
      var qtyInput = document.getElementById('Quantity-' + sectionId);
      if (qtyInput) {
        qtyInput.addEventListener('input',  function () { updatePricing(container); });
        qtyInput.addEventListener('change', function () { updatePricing(container); });
      }

      // Variant change — update base price
      if (formId) {
        var variantInput = document.querySelector('form#' + formId + ' input[name="id"]');
        if (variantInput) {
          variantInput.addEventListener('change', function () {
            var pricing = window.FFVolumePricing && window.FFVolumePricing[sectionId];
            if (pricing && pricing.variants[variantInput.value]) {
              container.dataset.basePrice = pricing.variants[variantInput.value];
              updatePricing(container);
            }
          });
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVolumePricing);
  } else {
    initVolumePricing();
  }
})();
